import React from 'react'
import Profile from './profile.js';
import Footer from './Footer/Footer';
import './align.css';
const Align = () => {
  return (
    <div className="home-container">
      
      <Profile/>
      <Footer/> 
    </div>
  )
}
export default Align
